import { useEffect, useRef, useState } from "react";

interface ImportProgress {
  current: number;
  total: number;
  lastAddress: string;
  isConnected: boolean;
}

export function useImportProgress(importId: string | null): ImportProgress {
  const [state, setState] = useState<ImportProgress>({
    current: 0,
    total: 0,
    lastAddress: "",
    isConnected: false,
  });
  const eventSourceRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (!importId) {
      setState({ current: 0, total: 0, lastAddress: "", isConnected: false });
      return;
    }

    const es = new EventSource(`/api/import-events/${importId}`);
    eventSourceRef.current = es;

    es.addEventListener("connected", () => {
      setState((prev) => ({ ...prev, isConnected: true }));
    });

    es.addEventListener("geocoding_progress", (e) => {
      const data = JSON.parse(e.data) as {
        current: number;
        total: number;
        lastAddress: string;
      };
      setState({
        current: data.current,
        total: data.total,
        lastAddress: data.lastAddress,
        isConnected: true,
      });
    });

    es.onerror = () => {
      setState((prev) => ({ ...prev, isConnected: false }));
    };

    return () => {
      es.close();
      eventSourceRef.current = null;
    };
  }, [importId]);

  return state;
}
